// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1q-0";
export var spinnerContainer = "_1q-1";